module.exports = __webpack_public_path__ + "static/media/Subtract-2.1805ac4c.svg";